module.exports = __webpack_public_path__ + "static/media/landing-testimonies.13da02ca.png";